module.exports = __webpack_public_path__ + "img/headline02.3468cb85.jpg";